module.exports = __webpack_public_path__ + "static/19-7cbb2d397c84b1308867d8688444211e.png";